import Icon from './components/Icon';
import Svg from './svg/circle-arrow.svg';
export default props => <Icon component={Svg} data-name="CircleArrow" {...props} />;